import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Box, Typography, Grid, TextField } from '@mui/material';
import TabSaveButton from './TabSaveButton';

export default function FinalOpinionForm(tabIndex) {
  const { control } = useFormContext();
  // 이 탭에서 관리하는 필드 경로
  const FIELD_PATHS = ['groupId', 'caseDescription', 'reporterOpinion', 'originalReporterOpinion'];

  return (
    <Box
      sx={{
        p: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        bgcolor: 'background.paper',
      }}
    >
      <Typography variant="h6" sx={{ mb: 2 }}>
        종합의견
      </Typography>

      <Grid container spacing={2}>
        {/* 1. 사례서술 */}
        <Grid size={{ xs: 12 }}>
          <Controller
            name="caseDescription"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextField
                {...field}
                id="caseDescription"
                name="caseDescription"
                label="1. 사례서술"
                multiline
                minRows={4}
                fullWidth
              />
            )}
          />
        </Grid>

        {/* 2. 보고자 의견 */}
        <Grid size={{ xs: 12 }}>
          <Controller
            name="reporterOpinion"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextField
                {...field}
                id="reporterOpinion"
                name="reporterOpinion"
                label="2. 보고자 의견"
                multiline
                minRows={4}
                fullWidth
              />
            )}
          />
        </Grid>

        {/* 3. 원보고자 의견 */}
        <Grid size={{ xs: 12 }}>
          <Controller
            name="originalReporterOpinion"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextField
                {...field}
                id="originalReporterOpinion"
                name="originalReporterOpinion"
                label="3. 원보고자 의견"
                multiline
                minRows={4}
                fullWidth
              />
            )}
          />
        </Grid>

        {/* 저장 버튼 */}
        <Grid size={{ xs: 12 }}>
          <TabSaveButton fieldPaths={FIELD_PATHS} label="탭 저장" index={tabIndex} />
        </Grid>
      </Grid>
    </Box>
  );
}
